import _ from 'lodash'
import { NODE_ID } from './treeHelper'
import { getComponentsByName } from '../../core/utils/KVdom'
// @fixme mixin 中引用当前组件会报错
// import KTreeNode from './TreeNode'

export const COMPONENT_NAME = 'KTreeNode'

export default {
  methods: {
    /**
     * 获取指定node的子节点
     * @param node
     * @returns {Array}
     */
    getChildren(node) {
      if (!node.$children || node.$children.length === 0) {
        return []
      }
      const children = getComponentsByName(node.$children, COMPONENT_NAME)
      if (children.length === 0) {
        return []
      }
      return children
    },

    /**
     * 使用data渲染TreeNode
     * @param data
     * @returns {any[]}
     */
    renderTreeNode(data) {
      return _.map(data, (item, index) => {
        const isLast = data.length - 1 === index
        return <KTreeNode
          key={item[NODE_ID]}
          data={item}
          level={this.level + 1}
          isLastChild={isLast}
        >
          {this.$scopedSlots.default}
        </KTreeNode>
      })
    },
  },
}
